import { css } from 'styled-system/css';

export const targetScrollableContainerStyles = {
	jupiterSimplePage: css({
		minH: '0',
	}),
	jupiterSimplePageScroll: css({
		h: '100%',
	}),
}